// @flow
// Normally, react-intl likes json files as input. I like having newlines for
// long strings, comments, and the occasional variable substitution; and these
// don't really mix. If we need JSON later, like for lazy-loading translation
// files, we'll change this thing to output it.
//
// Translators: I edit this file in a text editor. If you have a better program
// for translating text, but it requires a different file format (.po file?
// .json file? Google doc?), talk to me - maybe I can help.

const m = {}
export default m

const name = "War Swarms"

m["view.document.title"] = name
m["view.NavLayout.title"] = name
m["view.NavLayout.debug"] = "Debug"
m["view.NavLayout.meat"] = "Meat"
m["view.NavLayout.combat"] = "Combat"
m["view.NavLayout.mutations"] = "Mutations"
m["view.NavLayout.achievements"] = "Achievements"
m["view.NavLayout.options"] = "Settings"
m["view.NavLayout.characters"] = "Characters"
m["view.NavLayout.statistics"] = "Statistics"
m["view.NavLayout.rankings"] = "Rankings"
m["view.NavLayout.contact"] = "Send Feedback"

m["view.Options.title"] = "Settings"
m["view.Options.github.rss"] = "RSS feed"
m["view.Options.ClearSave.button"] = "Erase saved progress"
m["view.Options.NumberFormatChooser.title"] = "Number Format"
m["view.Options.NumberFormatChooser.standard"] = "Standard"
m["view.Options.NumberFormatChooser.engineering"] = "Engineering"
m["view.Options.NumberFormatChooser.scientific"] = "Scientific"
m["view.Options.NumberFormatChooser.hybrid"] = "Hybrid"
m["view.Options.NumberFormatChooser.longScale"] = "Long scale"
m["view.Options.NumberFormatChooser.examples"] = "Examples: {ex1}, {ex2}, {ex3}"
m["view.Options.IsDebug.title"] = "Show debugging information"
m["view.Options.PrereleaseFlags.title"] = "Enable secret prerelease features"

m["view.Privacy.title"] = "War Swarms and Your Privacy"

m["view.UserView.pleaseregister"] = "Register this account"
m["view.UserView.characterlist"] = "Character list"
m["view.UserView.login"] = "Login to another account"
m["view.UserView.createcharacter"] = "create character"
m["view.UserView.unnameduser"] = "Unnamed player"
m["view.UserView.publicprofile"] = "Your public profile"
m["view.UserView.mycharacters"] = "Your characters"
m["view.UserView.characters"] = "Character list"
m["view.UserView.created"] = "{username} started playing {ago}."

m["view.CharacterRouter.notyours"] = "You can't play this character. {link}"
m["view.CharacterRouter.notyours.link"] = "View this character instead."

m["view.CharacterView.owner"] = "Owner: {name}"
m["view.CharacterView.created"] = "Created: {time}"
m["view.CharacterView.units"] = "Meat"
m["view.CharacterView.combat"] = "Combat"
m["view.CharacterView.achievements"] = "Achievements"
m["view.CharacterView.statistics"] = "Statistics"
m["view.CharacterView.stuckactions"] =
  "{num} stuck actions. This bug may be causing your gameplay to lag."

m["view.CharacterList.title"] = "{displayName}'s characters"
m["view.CharacterList.since"] = "Played {since}"
m["view.CharacterList.noauth.nocharacters"] = "{displayName} has no characters."
m["view.CharacterList.auth.nocharacters"] =
  "To create your first character, press {icon} above."

m["leagues.standard"] = "Standard league"
m["leagues.overlord"] = "Overlord league"
m["leagues.prerelease"] = "Prerelease league"

m["view.NewCharacter.title"] = "Create a new character"
m["view.NewCharacter.field.displayName"] = "Name"
m["view.NewCharacter.field.league.standard.description"] =
  "Play using the normal War Swarms rules. More leagues with different rules are coming soon."
m["view.NewCharacter.field.league.overlord.description"] =
  "The first War Swarms temporary league."
m["view.NewCharacter.field.league.overlord.bullet1"] = "Conquer zones 6 to 9."
m["view.NewCharacter.field.league.overlord.bullet2"] =
  "Unlock the new Overlord unit, increasing the power of your other soldiers."
m["view.NewCharacter.field.league.templeagues.description"] =
  "Once this temporary league ends, your swarm will be playable in standard league."
m["view.NewCharacter.field.league.prerelease.description"] =
  "Play using the War Swarms rules used in the next release. Beta-test quality. Secret. Voided after the next release."
m["view.NewCharacter.field.league.comingsoon"] = "New leagues coming soon"
m["view.NewCharacter.field.league.countdown"] =
  "This league begins in {countdown}."
m["view.NewCharacter.submit"] = "Create character"
m["view.NewCharacter.error.isCharLimit"] = "Too many characters!"

m["view.UnitsList.title"] = "{displayName}'s units"
m["view.UnitsList.velocity"] = "+{value}/sec"

m["units.larva.plural"] = "{count, plural, one{larva} other{larvae}}"
m["units.larva.description"] = "Expansions now come from combat too."
m["units.larva.description.lol"] = "So much violence."
m["units.hatchery.plural"] = "{count, plural, one{hatchery} other{hatcheries}}"
m["units.hatchery.description"] =
  "You can't build hatcheries anymore! They come from combat now."
m["units.hatchery.description.lol"] =
  "Also, they're a real unit now, not an abomination of an upgrade"
m["units.meat.plural"] = "meat"
m["units.meat.description"] =
  "Aw man, I have to rewrite all these descriptions?"
m["units.meat.description.lol"] = "And all these tooltips?"
m["units.drone.plural"] = "{count, plural, one{drone} other{drones}}"
m["units.drone.description"] =
  "It'd be awfully lazy to reuse descriptions from the first game."
m["units.drone.description.lol"] =
  "That's not necessarily bad. I am nothing if not lazy."
m["units.queen.plural"] = "{count, plural, one{queen} other{queens}}"
m["units.queen.description"] =
  "We don't have to write them right now, though. Let's put it off a while longer."
m["units.queen.description.lol"] = "Procrastination wins again!"
m["units.nest.plural"] = "{count, plural, one{nest} other{nests}}"
m["units.nest.description"] =
  "Maybe later I'll be in the mood to write new unit descriptions."
m["units.nest.description.lol"] =
  "Or maybe I'll just copy them all from swarm1 in the end anyway. We'll see."
m["units.swarmling-queen.plural"] =
  "{count, plural, one{swarmling queen} other{swarmling queens}}"
m["units.swarmling-queen.description"] =
  "Spawn 2 swarmlings per second during combat. " +
  "This is a temporary unit. It'll be replaced later in the beta, once " +
  "combat's fleshed out a bit more. Don't get too attached."
m["units.tower.plural"] = "{count, plural, one{tower} other{towers}}"
m["units.tower.description"] = "Defensive combat structures."
m["units.overlord-den.plural"] =
  "{count, plural, one{overlord den} other{overlord dens}}"
m["units.overlord-den.description"] =
  "Spawn 1 overlord every 3 seconds during combat. " +
  "Overlords increase the attack power of all other troops."

m["soldiers.swarmling-queen"] = m["units.swarmling-queen.plural"]
m["soldiers.swarmling"] = "{count, plural, one{swarmling} other{swarmlings}}"
m["soldiers.tower"] = "{count, plural, one{tower} other{towers}}"
m["soldiers.overlord-den"] = m["units.overlord-den.plural"]
m["soldiers.overlord"] = "{count, plural, one{overlord} other{overlords}}"
m["soldiers.lair"] = "{count, plural, one{lair} other{lairs}}"

m["view.Achievements.title"] = "{displayName}'s achievements"
m["view.Achievements.status.pending"] = "No completion date recorded"
m["view.Achievements.hidden"] = "???"

m["view.AchievementsToast.title"] = "Achievement unlocked: {displayName}"

m["achievements.named"] = "All the good names were taken"
// This is "Build 1 drone". {units_drone_bought} is the number of drones required, and m[units.drone.plural] pluralizes based on that.
m["achievements.named.desc"] =
  "Name this character. Different characters may have the same name."
m["achievements.drone1"] = "It begins"
// This is "Build 1 drone". {units_drone_bought} is the number of drones required, and m[units.drone.plural] pluralizes based on that.
m["achievements.drone1.desc"] =
  "Build {units_bought_drone_text} " +
  m["units.drone.plural"].replace("count", "units_bought_drone_count")
m["achievements.drone2"] = "Supply limit exceeded"
m["achievements.drone2.desc"] = m["achievements.drone1.desc"]
m["achievements.drone3"] = "Banned near airports"
m["achievements.drone3.desc"] = m["achievements.drone1.desc"]
m["achievements.hatchery1"] = "Hatch Hatch Infinity"
m["achievements.hatchery1.desc"] =
  "Loot {units_looted_hatchery_text} " +
  m["units.hatchery.plural"].replace("count", "units_looted_hatchery_count")
m["achievements.hatchery2"] = "Path of Eggsire"
m["achievements.hatchery2.desc"] = m["achievements.hatchery1.desc"]
m["achievements.hatchery3"] = "AdVenture Hatchitallist"
m["achievements.hatchery3.desc"] = m["achievements.hatchery1.desc"]
m["achievements.zones1"] = "First blood"
m["achievements.zones1.desc"] =
  "Clear {zones_cleared_text} {zones_cleared_count, plural, one{zone} other{zones}}"
m["achievements.zones2"] = "Better than beta"
m["achievements.zones2.desc"] = m["achievements.zones1.desc"]

m["view.UnitView.title"] = "{charName}'s {unitName}"
m["view.UnitView.resource.list"] =
  "{length, plural, zero{nothing} one{{first}} =2{{first} and {last}} other{{head} and {last}}}"
m["view.UnitView.resource.listitem"] = "{item}, "
m["view.UnitView.resource.item"] = "{count} {unittype}"
m["view.UnitView.BuyN.help.title"] = "Purchasing Units"
m["view.UnitView.BuyN.help0"] = '"10%" buys 10% of the maximum you can afford.'
m["view.UnitView.BuyN.help1"] =
  '"=1000" buys exactly 1,000 after accounting for twins, rounded up.'
m["view.UnitView.BuyN.help2"] =
  '"@1000" buys the number needed to have at least 1,000 after the purchase. If you already have 200, this will buy at least 800.'
m["view.UnitView.BuyN.help3"] =
  'Numbers with suffixes or commas will work: "23 billion", "23b", "23,000,000,000", "23e9".'
m["view.UnitView.BuyN.cantbuy"] = "Can't buy"
m["view.UnitView.BuyN.buybutton"] = "Buy {name}"
m["view.UnitView.body.count"] = "You own {count} {name}."
m["view.UnitView.body.prodEach"] =
  "Each {name} produces {resources} per second."
m["view.UnitView.body.prodTotal"] =
  "In total, they produce {resources} per second."
m["view.UnitView.body.costeach"] = "Each {unitName} costs {cost}."
m["view.UnitView.body.velocity"] = "You generate {velocity} {name} per second."

m["view.UnitNav.allunits"] = "All units"

m["view.StatisticsView.title"] = "{displayName}'s statistics"
m["view.StatisticsView.production.title"] = "Production"
m["view.StatisticsView.production.col.name"] = "Worker"
m["view.StatisticsView.production.col.first"] = "First"
m["view.StatisticsView.production.col.bought"] = "Bought"
m["view.StatisticsView.production.col.clicks"] = "Buy-Clicks"
m["view.StatisticsView.production.col.spent"] = "Spent"
m["view.StatisticsView.production.col.looted"] = "Looted"
m["view.StatisticsView.production.col.grown"] = "Grown"
m["view.StatisticsView.combat.title"] = "Combat"
m["view.StatisticsView.combat.col.name"] = "Soldier"
m["view.StatisticsView.combat.col.first"] = "First"
m["view.StatisticsView.combat.col.produced"] = "Produced"
m["view.StatisticsView.combat.col.lost"] = "Casualties"
m["view.StatisticsView.combat.col.killed"] = "Kills"
m["view.StatisticsView.other.title"] = "Other"
m["view.StatisticsView.other.created"] = "Started at: {val}"
m["view.StatisticsView.other.totalclears"] = "Zones cleared: {val}"
m["view.StatisticsView.other.totalwins"] = "Battles won: {val}"
m["view.StatisticsView.other.totalfights"] = "Battles fought: {val}"

m["view.RegisterView.title"] = "Register"
m["view.RegisterView.description"] =
  "Attach an email and password to the account and characters you're playing now. Registration is strictly optional - feel free to skip this! - but it's the best way to avoid accidental loss of your account and beta code."
m["view.RegisterView.field.email"] = "Email address"
m["view.RegisterView.field.password"] = "Password"
m["view.RegisterView.field.password2"] = "Confirm password"
m["view.RegisterView.submit"] = "Register account"
m["view.RegisterView.error.anonymous"] =
  "Your account already has an email address."
m["view.RegisterView.error.passwordmatch"] = "Passwords must match."
m["view.RegisterView.success"] = "Registered successfully."
m["view.RegisterView.privacy"] = "Privacy"

m["view.LoginView.title"] = "Login"
//m['view.LoginView.description'] = "Log in to another account."
m["view.LoginView.description"] = "Played before? Log in."
m["view.LoginView.field.email"] = "Email address"
m["view.LoginView.field.password"] = "Password"
m["view.LoginView.submit"] = "Log in"
m["view.LoginView.forgot"] = "Forgot your password?"
m["view.LoginView.success"] = "Logged in successfully."
m["view.LoginView.privacy"] = "Privacy"

m["view.ResetPasswordView.title"] = "Reset your password"
m["view.ResetPasswordView.description"] =
  "We'll email you a link to set a new password."
m["view.ResetPasswordView.field.email"] = "Email address"
m["view.ResetPasswordView.submit"] = "Reset password"
m["view.ResetPasswordView.error.passwordmatch"] = "Passwords must match."
m["view.ResetPasswordView.success"] = "Password reset email sent."

m["view.ConfirmResetPasswordView.title"] = "Reset your password"
m["view.ConfirmResetPasswordView.description"] = "Enter your new password."
m["view.ConfirmResetPasswordView.field.password"] = "Password"
m["view.ConfirmResetPasswordView.field.password2"] = "Confirm password"
m["view.ConfirmResetPasswordView.error.passwordmatch"] = "Passwords must match."
m["view.ConfirmResetPasswordView.submit"] = "Update password"
m["view.ConfirmResetPasswordView.success"] = "Your password has been updated."

m["view.BetaKeyCreateView.title"] = "Create beta keys"

m["view.BetaKeyApplyView.title"] = "Join the " + name + " beta"
m["view.BetaKeyApplyView.description"] =
  "Applying beta code {betaKey} to your account {userId}."
m["view.BetaKeyApplyView.error.invalid"] = "That's not a beta key. Good try!"
m["view.BetaKeyApplyView.error.used"] = "Too slow! That beta key's taken."
m["view.BetaKeyApplyView.error.alreadyaccess"] =
  "You already have beta access. Shoo."
m["view.BetaKeyApplyView.submit"] = "Join the beta"
m["view.BetaKeyApplyView.success"] =
  "Welcome to the " + name + " closed beta test!"

m["view.TitleView.welcome"] = name + " - closed beta"
m["view.TitleView.welcomeback"] = "Welcome back, {displayName}."
m["view.TitleView.betawarn"] =
  "War Swarms is in very early beta testing. Things aren't done yet - we'll be adding a lot in the coming weeks, and your feedback is welcome. Thanks for being patient with us."
// TODO support xlations with <p>aragraphs, and rich text in general. That could
// mean a new translation package that allows jsx syntax, but markdown with
// linebreaks would also be sufficient.
m["view.TitleView.desc1"] =
  "The swarm, a race of bug-like aliens, prospered under the rule of the ancient Overminds."
m["view.TitleView.desc2"] =
  "Without warning, the Overminds vanished. Their disappearance shattered the unity of their underlings, and left many smaller, fractured swarms behind. Some swarms now wander leaderless and confused, some let their bloodthirsty instincts run wild, and some vie for power and control over the others."
m["view.TitleView.desc3"] =
  "Grow your fledgling swarm, fight your way back to dominance, and discover what fate befell the Overminds - all with no graphics."
m["view.TitleView.unauthed.play"] = "Begin playing"
m["view.TitleView.unauthed.login"] = "Log in"
m["view.TitleView.authed.play"] = "Continue playing"
m["view.TitleView.authed.logout"] = "Log out"
m["view.TitleView.authed.register"] = "Register an email address"
m["view.TitleView.authed.register.help"] =
  "Register now to play from other devices and protect your progress! 100% optional."
m["view.TitleView.betadesc"] =
  name +
  " is currently in closed beta testing. You must have a beta invitation code to begin playing. Visit {link} for updates."
m["view.TitleView.version"] = "Version: {version}"
m["view.TitleView.versions"] =
  "Version: client {clientVersion}, server {serverVersion}"
m["view.TitleView.privacy"] = "Privacy"

m["view.Rankings.title"] = "Rankings: {rankName}"

m["view.Combat.comingsoon"] = "Coming soon"

m["flags.logFirebase"] =
  "Show firebase/react-redux-firebase console logs. http://react-redux-firebase.com/docs/api/compose.html#reactreduxfirebase"
m["flags.dumpProps"] =
  "Show the props passed to the current view at the bottom of the page. Passwords are masked."
m["flags.logProps"] =
  "Show the props passed to the current view in the console logs. One console.log() per render. Passwords are NOT masked."
m["flags.offline"] =
  "Instead of real Firebase data, use a fixed set of offline data. Most things won't work, but it's good enough for unittests and occasional Internet-free development."
m["flags.stoptime"] =
  "Disable client-side time updates (TICK actions) after reload. Useful for reducing noise while debugging non-time things. Server-side time marches on, so most server interaction will fail."
m["flags.freshdesk"] =
  'Show the Freshdesk "send feedback" widget. Disable while running Lighthouse: they don\'t like each other.'
m["flags.isPrereleaseFlags"] = "Top-secret unreleased features. Shh."
m["flags.multiSoldierCombat"] = "So many more kinds of things to kill."
m["flags.unlockZone6"] = "Show new zones."
m["flags.releaseCountdown"] =
  "Show a countdown timer until the next release. Link to a relevant news post."

m["rankings.meat"] = "Meat produced"
m["rankings.drone"] = "Drones produced"
m["rankings.queen"] = "Queens produced"
m["rankings.nest"] = "Nests produced"
m["rankings.hatchery"] = "Hatcheries captured"
m["rankings.achievements-count"] = "Achievements earned"
m["rankings.zones-cleared"] = "Zones cleared"

m["zone.zone1"] = "Zone 1"
m["zone.zone1.description"] =
  "This is the first zone! Defeat the foes here to get your first hatchery and expansion."
m["zone.zone1.description.lol"] = "You always remember your first"
m["zone.zone2"] = "Zone two"
m["zone.zone2.description"] =
  "You can grind the same zone a few times in a row for a few more hatcheries (there is a limit), but a zone only awards an expansion for your first win."
m["zone.zone2.description.lol"] = "No cost for trying new zones, though!"
m["zone.zone3"] = "Zone three"
m["zone.zone3.description"] =
  "Zones aren't infinite. They'll have names and a plot soon. Clearing zones will advance the plot, among other things."
m["zone.zone3.description.lol"] =
  "They'll have real descriptions and real mouseovers too."
m["zone.zone4"] = "Zone 4"
m["zone.zone4.description"] =
  "You'll get the infinitely-scaling zones you expect from your incremental games later. We're not there quite yet."
m["zone.zone4.description.lol"] =
  "I'm not sure what we'll call them just yet. Greater Rifts is already taken."
m["zone.zone5"] = "Zone 5"
m["zone.zone5.description"] =
  "This is a fairly short beta right now. There'll be more soon."
m["zone.zone5.description.lol"] = "ZOMG, HURRY UP DEV"
m["zone.zone6"] = "Zone 6"
m["zone.zone6.description"] = "Look, a shiny new unit!"
m["zone.zone6.description.lol"] = "shiny shiny shiny"
m["zone.zone7"] = "Zone 7"
m["zone.zone7.description"] =
  "Overlords unlocked! Try building some. They're pretty powerful."
m["zone.zone7.description.lol"] = ""
m["zone.zone8"] = "Zone 8"
m["zone.zone8.description"] =
  "Overlord dens and swarmling queens will be going away in a future update, though."
m["zone.zone8.description.lol"] = ""
m["zone.zone9"] = "Zone 9"
m["zone.zone9.description"] =
  "There'll be a different way to upgrade your armies pretty soon."
m["zone.zone9.description.lol"] = ""

m["view.CombatForm.title"] = "Combat"
m["view.CombatForm.feeding"] =
  "Spending {meat} meat. Your soldiers will be {buff} stronger in this battle."
m["view.CombatForm.zone"] = "Zone"
m["view.CombatForm.submit"] = "Attack"
m["view.CombatForm.yourarmy"] = "Your army"
m["view.CombatForm.nounits"] =
  "Build some swarmling queens before beginning combat."
m["view.CombatForm.expansion"] =
  "You've expanded into {zoneClearText} {zoneClears, plural, one{zone} other{zones}}. Your hatcheries are {hatcheryProdBonus} more productive."
m["view.CombatForm.grinding"] =
  "You've beaten this zone before. Your next {grindCount, plural, one{attack} other{{grindCountText} attacks}} will award loot."
m["view.CombatForm.nogrind"] =
  "You've been attacking a lot recently - your next attack will award no loot. Try attacking a zone you haven't beaten yet!"
m["view.CombatForm.grinding.lol"] =
  "Because an idle game that benefits from nonstop clicking would be silly."

m["view.CombatRun.title"] = "Combat: {zone}"
m["view.CombatRun.soldier.name"] =
  "{count, plural, one{{soldier}} other {{countText} {soldier}}}"
m["view.CombatRun.soldier.hp"] =
  "{count, plural, one{{hpText} hp} other{{maxHpText} hp}}{attack, plural, =0{} other{/{attackText} attack}} {count, plural, one{} other{each}}"

m["view.CombatResult.win.title"] = "Victory!"
m["view.CombatResult.win.firststatus"] =
  "Cleared {zone} for the first time! Your hatcheries now produce " +
  "{hatcheryProdPerZone} more larvae."
m["view.CombatResult.win.status"] = "Cleared {zone}"
m["view.CombatResult.win.lootitem"] = "You gain {count} {unitName}."
m["view.CombatResult.lose.title"] = "Defeat!"
m["view.CombatResult.lose.status"] = "Failed to clear {zone}"
m["view.CombatResult.draw.title"] = "Draw!"
m["view.CombatResult.draw.status"] = "Failed to clear {zone}"

m["view.ReleaseCountdown.over"] = "New release!"
m["view.ReleaseCountdown.counting"] = "New release in {countdown}"



// WEBPACK FOOTER //
// ./src/lang/en.js